import {useEffect} from 'react';
import ReactDOM from 'react-dom';
import {unsubscribeEvents} from '@dazn/lp-web/src/analytics/fe-events';
import {isWebAuthFunnelEnabled} from '@dazn/lp-web/src/features/getWebAuthFunnel';
import {logEvent} from '@dazn/lp-web/src/utils';

export function useOnInitialPageLoad(root: any) {
    if (isWebAuthFunnelEnabled) {
        logEvent('web_auth_funnel', {
            step: 'LP Page Loaded',
            is3ppExit: '',
            productGroup: '',
            entitlementSetId: '',
            billingPeriod: '',
            platform: 'Web'
        });
    }

    useEffect(() => {
        const onUnload = (): Promise<void> => {
            unsubscribeEvents();
            ReactDOM.unmountComponentAtNode(root);
            return Promise.resolve();
        };
        document.title = 'DAZN';
        window.dazn.lifecycle.onChapterUnload(onUnload);

        const themeColorMeta = document.querySelector(
            'meta[name="theme-color"]'
        );
        if (themeColorMeta) {
            themeColorMeta.setAttribute('content', 'rgba(0,0,0,0.1)');
        } else {
            const newMeta = document.createElement('meta');
            newMeta.name = 'theme-color';
            newMeta.content = 'rgba(0,0,0,0.1)';
            document.head.appendChild(newMeta);
        }
    }, [root]);
}
